<template>
  <div class="tva-content-switcher">
    <div
      :class="[
        'tva-content-switcher-item',
        { active: index === selectedIndex }
      ]"
      v-for="(item, index) in content"
      @click="click(index)"
      :key="index"
    >
      {{ item.label }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"],
  data() {
    return {
      selectedIndex: 0
    };
  },
  methods: {
    click(index) {
      this.selectedIndex = index;
      this.content.forEach((element, i) => {
        element.active = false;
        if (i === index) {
          element.active = true;
        }
      });

      this.$emit("click", this.content);
    }
  }
};
</script>
<style lang="scss" scoped>
.tva-content-switcher {
  display: flex;
  margin: 1em 0;
}
</style>
